import React from 'react';
import ProductImageItem from './ProductImageItem';
import ProductVideoItem from './ProductVideoItem';
import { ProductMediaGridProps } from '../interfaces';
import './ProductMediaGrid.scss';


const ProductMediaGrid: React.FC<ProductMediaGridProps> = ({
  items,
  loadedImages,
  cursorPosition,
  zoomedImageId,
  onImageLoad,
  onImageError,
  onPointerMove,
  onImageClick,
}) => (
  <div className="images-grid">
    {items.map((media) => {
      if (media.type === 'video') {
        return <ProductVideoItem key={media.id} media={media} />;
      }

      return (
        <ProductImageItem
          key={media.id}
          media={media}
          isLoaded={loadedImages[media.id]?.showImage}
          isZoomed={zoomedImageId === media.id}
          pointer={cursorPosition[media.id] || { x: 50, y: 50 }}
          onLoad={onImageLoad}
          onError={onImageError}
          onPointerMove={onPointerMove}
          onClick={onImageClick}
        />
      );
    })}
  </div>
);

export default ProductMediaGrid;
